const Elbow_questions = [
   {
      "question":"How is ##name## being evaluated today?",
      "sub":"",
      "type":"radio",
      "telehealth":"form1[0].#subform[0].Public2507Questions[0].HowExamCOnducted[0]",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "questions":[
         {
            "label":"How was the examination conducted?",
            "title":"",
            "subMain":"",
            "sub":"",
            "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[2]",
            "options":[
               {
                  "main":"In-Person Exam",
                  "dbqName":"1",
                  "sub":""
               },
               {
                  "main":"Video Telehealth",
                  "dbqName":"2",
                  "sub":""
               }
            ],
            "answer":"In-Person Exam"
         }
      ]
   },
   {
      "question":"Is ##name## regularly seen as a patient in your clinic?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "Disability Benefits Questionnaire",
         number: "0"
      },
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].Public2507Questions[0].RadioButtonList[1]",
      "ref":0,
      "dbqName_yes":"1",
      "dbqName_no":"2",
      "answer":"",
   },
   {
      "question":"Did you review any of the patients records for this condition?",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "1",
         title: "EVIDENCE REVIEW",
         number: "0"
      },
      "maxLength":90,
      "presidence":"Yes",
      "radioGroup":"form1[0].#subform[0].PublicEvidenceReview[0].RadioButtonList[0]",
      "ref":0,
      "dbqName_yes":"2",
      "dbqName_no":"1",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please identify the evidence reviewed and the date range",
      "textdbqName":"form1[0].#subform[0].PublicEvidenceReview[0].IdentifyEvidence[0]",
      "textanswer":""
   },
   {
      "question":"ROM Measurements After Repetitive Use Testing for ##redHeading##",
      "redHeading": "Right Elbow",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Flexion",
            "subMain":"Normal Endpoint is 145 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[1]",
            "defaultVal":"145",
            "values":["145", "140", "135", "130", "125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"145"
         },
         {
            "main":"Extension",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[2]",
            "defaultVal":"0",
            "values":["80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5", "0"],
            "answer":"0"
         },
         {
            "main":"Forearm Supination",
            "subMain":"Normal Endpoint is 85 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[3]",
            "defaultVal":"85",
            "values":["85","80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5", "0"],
            "answer":"85"
         },
         {
            "main":"Forearm Pronation",
            "subMain":"Normal Endpoint is 80 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[0]",
            "defaultVal":"80",
            "values":["80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"80"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##? ",
      "redHeading" : "Right Elbow",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Flexion",
            "dbqName":"form1[0].#subform[6].Right_ExternalPain[9]",
            "answer":""
         },
         {
            "main":"Extension",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain[3]",
            "answer":""
         },
         {
            "main":"Forearm Supination",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain[4]",
            "answer":""
         },
         {
            "main":"Forearm Pronation",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain[5]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }      
      ],
      "answer":""
   },
   {
      "question":"ROM Measurements After Repetitive Use Testing for ##redHeading##",
      "redHeading": "Left Elbow",
      "sub":"",
      "type":"text",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Flexion",
            "subMain":"Normal Endpoint is 145 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[13]",
            "defaultVal":"145",
            "values":["145", "140", "135", "130", "125", "120", "115", "110", "105", "100", "95", "90", "85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"145"
         },
         {
            "main":"Extension",
            "subMain":"Normal Endpoint is 0 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[14]",
            "defaultVal":"0",
            "values":["80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5", "0"],
            "answer":"0"
         },
         {
            "main":"Forearm Supination",
            "subMain":"Normal Endpoint is 85 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[15]",
            "defaultVal":"85",
            "values":["85", "80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5", "0"],
            "answer":"85"
         },
         {
            "main":"Forearm Pronation",
            "subMain":"Normal Endpoint is 80 Degrees",
            "sub":"Post-Test ROM Measurement",
            "type":"select",
            "dbqName":"form1[0].#subform[6].ROM2[12]",
            "defaultVal":"80",
            "values":["80", "75", "70", "65", "60", "55", "50", "45", "40", "35", "30", "25", "20", "15", "10", "5"],
            "answer":"80"
         }
      ]
   },
   {
      "question":"Which ROM exhibited pain for ##redHeading##? ",
      "redHeading" : "Left Elbow",
      "sub":"Check all that apply",
      "type":"radioTiles",
      "multi": true,
      "show": true,
      "small": true,
      "partial": true,
      "cols": 2,
      "questions":[
         {
            "main":"Flexion",
            "dbqName":"form1[0].#subform[6].Right_ExternalPain[14]",
            "answer":""
         },
         {
            "main":"Extension",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain[6]",
            "answer":""
         },
         {
            "main":"Forearm Supination",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain[7]",
            "answer":""
         },
         {
            "main":"Forearm Pronation",
            "dbqName":"form1[0].#subform[6].Right_PlantarPain[8]",
            "answer":""
         },
         {
            "main":"None",
            "dbqName":"pass_this_question",
            "partialField": true,
            "answer":""
         }             
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Right Elbow",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 3,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[0],form1[0].#subform[6].Right_Limitation[0]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[2],form1[0].#subform[6].Right_Limitation[0]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[1],form1[0].#subform[6].Right_Limitation[0]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[3],form1[0].#subform[6].Right_Limitation[0]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[6].Right_NoPain[0],form1[0].#subform[6].Right_Limitation[0]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[6].Right_PainNoFunctionalLoss[0],form1[0].#subform[6].Right_Limitation[0]",
            "answer":"",
            "textarea": true,
            "maxLength": 135,
            "textdbqName" : "form1[0].#subform[6].ExplainWhy[10]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[6].Right_PainOnRest[0],form1[0].#subform[6].Right_Limitation[0]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[6].Right_Limitation[1]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there evidence of pain for ##redHeading##?",
      "redHeading":"Left Elbow",
      "sub":"",
      "type":"radioTiles",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 3,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "main":"Weight-bearing",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[4],form1[0].#subform[6].Right_Limitation[6]",
            "answer":""
         },
         {
            "main":"Active motion",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[6],form1[0].#subform[6].Right_Limitation[6]",
            "answer":""
         },
         {
            "main":"Non-weight bearing",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[5],form1[0].#subform[6].Right_Limitation[6]",
            "answer":""
         },
         {
            "main":"Passive motion",
            "dbqName":"form1[0].#subform[6].Right_PainWithFunctionalLoss[7],form1[0].#subform[6].Right_Limitation[6]",
            "answer":""
         },
         {
            "main":"On Rest/Non-movement",
            "dbqName":"form1[0].#subform[6].Right_NoPain[1],form1[0].#subform[6].Right_Limitation[6]",
            "answer":""
         },
         {
            "main":"Causes functional loss",
            "dbqName":"form1[0].#subform[6].Right_PainNoFunctionalLoss[1],form1[0].#subform[6].Right_Limitation[6]",
            "answer":"",
            "textarea": true,
            "textdbqName" : "form1[0].#subform[6].ExplainWhy[11]",
            "placeholder": "describe in the functional loss",
            "textAnswer": ""
         },
         {
            "main":"Does not result in/cause functional loss",
            "dbqName":"form1[0].#subform[6].Right_PainOnRest[1],form1[0].#subform[6].Right_Limitation[6]",
            "answer":""
         },
         {
            "main":"None",
            "partialField": true,
            "dbqName":"form1[0].#subform[6].Right_Limitation[7]",
            "answer":""
         }            
      ],
      "answer":""
   },
   {
      "question":"Is there objective evidence of crepitus?",
      "sub":"",
      "type":"radio",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "questions":[
         {
            "label":"Right Elbow",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[6].Right_Limitation[2]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[6].Right_Limitation[3]",
                  "sub":""
               }
            ],
            "answer":"No"
         },
         {
            "label":"Left Elbow",
            "title":"",
            "subMain":"",
            "sub":"",
            "options":[
               {
                  "main":"Yes",
                  "dbqName":"form1[0].#subform[6].Right_Limitation[8]",
                  "sub":""
               },
               {
                  "main":"No",
                  "dbqName":"form1[0].#subform[6].Right_Limitation[9]",
                  "sub":""
               }
            ],
            "answer":"No"
         }
      ]
   },
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading":"Right Elbow",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "maxLength": 135,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[6].Right_Limitation[4]",
      "dbqName_no":"form1[0].#subform[6].Right_Limitation[5]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationsElbow to condition(s)",
      "textdbqName":"form1[0].#subform[6].ExplainWhy[8]",
      "textanswer":""
   },   
   {
      "question":"Is there objective evidence of localized tenderness or pain on palpation of the joint or associated soft tissue for ##redHeading##?",
      "redHeading":"Left Elbow",
      "sub":"",
      "type":"yesno",
      "show": true,
      "section": {
         page: "4",
         title: "RANGE OF MOTION (ROM) AND FUNCTIONAL LIMITATION",
         number: "3A"
      },
      "maxLength":135,
      "presidence":"Yes",
      "ref":0,
      "dbqName_yes":"form1[0].#subform[6].Right_Limitation[10]",
      "dbqName_no":"form1[0].#subform[6].Right_Limitation[11]",
      "answer":"",
      "istext": true,
      "textarea": false,
      "placeholder": "Please explain. Include location, severity, and relationsElbow to condition(s)",
      "textdbqName":"form1[0].#subform[6].ExplainWhy[12]",
      "textanswer":""
   },

   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Right elbow",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "SURGICAL PROCEDURES",
         number: "7A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[10].LeftSide[2]",
                  "partialField": true,
                  "answer":"",
               },   
               {
                  "main":"Total elbow joint replacement",
                  "dbqName":"form1[0].#subform[10].LeftSide[0]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "placeholderDate1":"Date for Surgery",
                  "dbqDate1": "form1[0].#subform[10].DateOfSurgery[1]",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[10].Residuals[0]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[10].Residuals[3]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[10].Residuals[1]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[10].Residuals[2]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[10].OtherDescribe[2]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other elbow surgery",
                  "dbqName":"form1[0].#subform[10].LeftSide[1]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[10].TypeofSurgery[0]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].DateOfSurgery[0]",
                  "text2": "",
                  "dbqName2": "form1[0].#subform[10].OtherDescribe[0]",
                  "placeholder2":"Describe residuals",
                  
               },
                                    
            ],
            "answer":""
   },
   {
      "question":"Indicate any surgical procedures that ##name## has had performed for ##redHeading## and provide the additional information as requested?",
      "redHeading":"Left elbow",
      "sub":"",
      "type":"radioModal",
      "multi": true,
      "partial": true,
      "show": true,
      "small": true,
      "cols": 2,
      "section": {
         page: "8",
         title: "SURGICAL PROCEDURES",
         number: "7A"
      },
      "questions":[
               {
                  "main":"No surgery",
                  "dbqName":"form1[0].#subform[10].LeftSide[5]",
                  "partialField": true,
                  "answer":"",
               },  
               {
                  "main":"Total elbow joint replacement",
                  "dbqName":"form1[0].#subform[10].LeftSide[3]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].DateOfSurgery[3]",
                  "subItems": [
                     {
                        "main":"None",
                        "dbqName":"form1[0].#subform[10].Residuals[4]",
                        "colWidth": 3,
                        "answer":""
                     },
                     {
                        "main":"Intermediate degrees of residual weakness, pain, or limitation of motion",
                        "dbqName":"form1[0].#subform[10].Residuals[7]",
                        "colWidth": 9,
                        "answer":""
                     },
                     {
                        "main":"Other",
                        "dbqName":"form1[0].#subform[10].Residuals[5]",
                        "colWidth": 3,
                        "subItemLinked": true,
                        "answer":""
                     },
                     {
                        "main":"Chronic residuals consisting of severe painful motion or weakness",
                        "dbqName":"form1[0].#subform[10].Residuals[6]",
                        "colWidth": 9,
                        "answer":""
                     }
                     
                  ],
                  "subAnswer":"",
                  "subItemsLabel" :"Residuals",
                  "subItemOther": false,
                  "textOther": "",
                  "dbqNameOther": "form1[0].#subform[10].OtherDescribe[4]",
                  "placeholderOther":"Other residuals describe",
               },
               {
                  "main":"Arthroscopic or other elbow surgery",
                  "dbqName":"form1[0].#subform[10].LeftSide[4]",
                  "answer":"",
                  "multi": false,
                  "showSubItems": false,
                  "text1": "",
                  "dbqName1": "form1[0].#subform[10].TypeofSurgery[1]",
                  "placeholder1":"Type of surgery",
                  "date1": "",
                  "dbqDate1": "form1[0].#subform[10].DateOfSurgery[2]",
                  "text2": "",
                  "dbqName2": "form1[0].#subform[10].OtherDescribe[3]",
                  "placeholder2":"Describe residuals"
               },
                                     
            ],
            "answer":""
   },

   {
      "question":"Additional Comments",
      "sub":"",
      "optional": true,
      "type":"textarea",
      "maxLength":360,
      "show": true,
      "section": {
         page: "9",
         title: "REMARKS",
         number: "13A"
      },
      "options":[],
      "dbqName":"form1[0].#subform[11].Comments6[1]",
      "answer":""
   }
]

export default Elbow_questions;